import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  ToastifyContainer: {
    "&.Toastify__toast-container": {
      maxWidth: 1200,
      width: "auto",
      padding: "0",
      bottom: 16,
      "@media (max-width: 600px)": {
        width: "100%",
        paddingLeft: 24,
        paddingRight: 24
      }
    }
  },
  ToastifyMain: {
    "&.Toastify__toast": {
      borderRadius: 12,
      paddingTop: 24,
      paddingRight: 72,
      paddingBottom: 24,
      paddingLeft: 16,
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.08), 0px 16px 16px rgba(0, 0, 0, 0.08)",
      position: "relative",
      border: "1px solid",
      margin: 0,
      "& + &": {
        marginTop: 16
      },
      "& .Toastify__toast-body": {
        margin: 0,
        padding: 0,
        "& .Toastify__toast-icon": {
          display: "none"
        },
        "& > div": {
          display: "flex",
          fontFamily: "Montserrat, sans-serif",
          fontSize: 16,
          lineHeight: 1.5,
          fontWeight: 500,
          color: "#2D2442",
          textAlign: "left",
          wordWrap: "break-word",
          "&:before": {
            content: "''",
            width: 24,
            height: 24,
            marginRight: 16,
            flexShrink: 0,
            backgroundSize: 24
          }
        }
      },
      "& .Toastify__close-button": {
        width: 24,
        height: 24,
        position: "absolute",
        top: 24,
        right: 24,
        opacity: 1,
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z' fill='%23FFFFFF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A\")",
        "& svg": {
          display: "none",
        }
      },
      "&.Toastify__toast--error": {
        backgroundColor: "#FDE3E9",
        borderColor: "rgba(238, 66, 106, 0.4)",
        "& .Toastify__toast-body": {
          "& > div": {
            "&:before": {
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23EE426A'/%3E%3Crect x='11' y='7' width='2' height='7' rx='1' fill='white'/%3E%3Ccircle cx='12' cy='16' r='1' fill='white'/%3E%3C/svg%3E%0A\")"
            }
          }
        },
        "& .Toastify__close-button": {
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z' fill='%23EE426A'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289Z' fill='%23EE426A'/%3E%3C/svg%3E%0A\")"
        }
      },
      "&.Toastify__toast--info": {
        backgroundColor: "#E3F1E2",
        borderColor: "rgba(101, 193, 93, 0.4)",
        "& .Toastify__toast-body": {
          "& > div": {
            "&:before": {
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='12' fill='%2365C15D'/%3E%3Cpath d='M8 11.3327L10.9274 14.5854C10.9665 14.6288 11.0344 14.6296 11.0745 14.5872L16.6667 8.66602' stroke='white' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A\")"
            }
          }
        },
        "& .Toastify__close-button": {
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z' fill='%2365C15D'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289Z' fill='%2365C15D'/%3E%3C/svg%3E%0A\")"
        }
      }
    }
  }
});